import React from 'react'
import { Dialog, DialogContent, Grid, Link, TextField, MenuItem, BottomNavigationAction } from '@material-ui/core';
import Header from './Header';
import ActionBar from './ActionBar';
import SaveIcon from '@material-ui/icons/Save';
import Image from './Image'
import { getErrorProps } from '../utils'

const PhotoDetails = ({ formik, onSubmit, onClose, upload, readonly }) => {
  const author = `upload.author`
  const remarks = `upload.remarks`
  const origname = `upload.origname`
  const publish = `upload.publish`

  return (
    <>
      {upload &&
        <Dialog open={true} fullScreen  style={{ marginBottom: '57px' }}>
          <Header title={formik.values.upload.origname} backAction={onClose} />
          <DialogContent>
            <Grid container>
            <Grid item xs={12}>
                <Image upload={upload} fullSize />
              </Grid>
              <Grid item xs={12}>
                <TextField disabled={readonly} label="naam" variant="standard" name={origname} fullWidth  {...getErrorProps(formik, origname)} {...formik.getFieldProps(origname)} />
              </Grid>
              <Grid item xs={12}>
                <TextField disabled={readonly} select label="vrij te gebruiken" variant="standard" name={publish} fullWidth  {...getErrorProps(formik, publish)} {...formik.getFieldProps(publish)}>
                  <MenuItem key={0} value={0}>Nee</MenuItem>
                  <MenuItem key={1} value={1}>Ja</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField disabled={readonly} label="naam fotograaf" variant="standard" name={author} fullWidth  {...getErrorProps(formik, author)} {...formik.getFieldProps(author)} />
              </Grid>
              <Grid item xs={12}>
                <TextField disabled={readonly} label="bijschrift" variant="standard" name={remarks} multiline fullWidth  {...getErrorProps(formik, remarks)} {...formik.getFieldProps(remarks)} />
              </Grid>
            </Grid>
          </DialogContent>
          {!readonly &&
            <ActionBar>
              {!readonly && <BottomNavigationAction label="Fotogegevens opslaan" component={Link} to="/" onClick={onSubmit} style={{ color: '#00547d' }} icon={<SaveIcon />} />}
            </ActionBar>}
        </Dialog>}
    </>
  )
};

export default PhotoDetails;
